export default __webpack_public_path__ + "static/media/difficulty.8d438a6f.svg";